export enum HistoryFilterContextActionType {
  ORDER = 'ORDER',
  RESTAURANTS = 'RESTAURANTS',
  DATES = 'DATES',
  ACTION = 'ACTION',
  PAGE = 'PAGE',
  ORDER_ID = 'ORDER_ID',
}
